import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSliderThumb = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 19,
	fill: "none",
	viewBox: "0 0 19 19",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 9.5,
		cy: 9.5,
		r: 9.5,
		fill: "currentColor"
	})
});
export default SvgSliderThumb;
